var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.success)?_c('SuccessPayment',{attrs:{"info":_vm.data}}):_vm._e(),(_vm.failed)?_c('FailedPayment',{attrs:{"info":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }